// Copyright (c) 2017 Deere & Company

import SystemSelectedClaimsAccordion from './system-selected-claims-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    auditPreparation: state.tcsm.prepareAudit.auditPreparation
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => {

    const {
        updateSystemSelectedClaimsModalVisibility
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            updateSystemSelectedClaimsModalVisibility
        }
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(SystemSelectedClaimsAccordion);



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/system-selected-claims-accordion/index.js